import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import FileUpload from "../../../../../../components/FileUpload";
import './Bots.css';
import Design from "./Design";
import Functions from "./Functions";
import Resources from "./Resources";
import Members from "./Members";
import IntegrationsIcon from 'assets/images/integrations.png';
import FunctionsIcon from 'assets/images/functions.png';
import UsersIcon from 'assets/images/users-icon.png';
import BlackListIcon from 'assets/images/black-list.png';
import DesignIcon from 'assets/images/design.png';
import CategoriesIcon from 'assets/images/categories.png';
import ConfigurationsIcon from 'assets/images/configuration.png';
import CreateClientIcon from 'assets/images/create-client.png';
import Translate from "../../../../../../components/Translate";
import Configurations from "./Configurations";
import Channels from './Channels';
import Separator from "../../../../../../assets/Separator";
import BlackList from './BlackList';
import config from "../../../../../../config";
import Tooltip from "../../../../../../components-new/Tooltip";
import {updateClientName} from "../../../../../../services/company/api";
import {inputStyles, titleStyles} from "../../../../../../utils/General";

const Bots = ({
                  clients,
                  openCreateClientModal,
                  handleRemoveClient,
                  handleImageChange,
                  user,
                  tariff,
                  addNotification
              }) => {
    const {features} = tariff;
    const [visibleClient, setVisibleClient] = useState(null);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [editingClientId, setEditingClientId] = useState(null);
    const [editedClientName, setEditedClientName] = useState('');
    const [localClients, setLocalClients] = useState([]);

    useEffect(() => {
        setLocalClients(clients);
    }, [clients]);

    useEffect(() => {
        if (clients.length > 0) {
            setVisibleClient(clients[0]);
            setActiveSubMenu(0);
        } else {
            setVisibleClient(null);
            setActiveSubMenu(null);
        }
    }, [clients]);

    useEffect(() => {
        const savedClientId = localStorage.getItem("selectedClientId");
        if (savedClientId && clients.length > 0) {
            const foundClient = clients.find(client => client.id === savedClientId);
            if (foundClient) {
                setVisibleClient(foundClient);
                setActiveSubMenu(0);
            }
        } else if (clients.length > 0) {
            setVisibleClient(clients[0]);
            setActiveSubMenu(0);
        }
    }, [clients]);

    const toggleVisibility = (client) => {
        const newClient = visibleClient && visibleClient.id === client.id ? null : client;
        setVisibleClient(newClient);
        setActiveSubMenu(null);

        if (newClient) {
            localStorage.setItem("selectedClientId", newClient.id);
        } else {
            localStorage.removeItem("selectedClientId");
        }
    };

    const handleSubMenuClick = (index) => {
        setActiveSubMenu(activeSubMenu === index ? null : index);
    };

    const handleClientNameUpdate = async (clientId, newName) => {
        if (!newName.trim()) return;

        try {
            await updateClientName(clientId, newName);
            setEditingClientId(null);

            setLocalClients(prev =>
                prev.map(client =>
                    client.id === clientId ? {...client, name: newName} : client
                )
            );

            addNotification("successful", config.notificationLevels.success);
        } catch (err) {
            console.error("Failed to update client name", err);
            addNotification("somethingWentWrong", config.notificationLevels.error);
        }
    };

    return (
        <div className="bots-container">
            <div className={`bots-sidebar ${activeSubMenu !== null ? 'bots-sidebar-collapsed' : ''}`}>
                <div onClick={openCreateClientModal} className="bots-button-div">
                    <h2 style={{...titleStyles.title, marginBottom: '0px', fontSize: '12px'}}>
                        <Translate text={'create'}/>
                    </h2>
                    <img src={CreateClientIcon} onClick={openCreateClientModal}/>
                </div>
                <Separator/>
                {localClients.map((client, index) => (
                    <div
                        key={client.id}
                        className={`bots-bot-div ${visibleClient && visibleClient.id === client.id ? 'bots-selected' : ''}`}
                        onClick={() => toggleVisibility(client)}
                    >
                        <Tooltip needTranslate={false} text={client.name}>
                            <div className="bots-header">
                                <FileUpload windowSize={44} editIconSize={16} progressSize={22} editIconPos={0}
                                            handleChange={handleImageChange} client={client} image={client.image}/>
                                {editingClientId === client.id ? (
                                    <input
                                        id={'edit-input-' + client.id}
                                        type="text"
                                        value={editedClientName}
                                        autoFocus
                                        onChange={(e) => setEditedClientName(e.target.value)}
                                        onBlur={() => handleClientNameUpdate(client.id, editedClientName)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleClientNameUpdate(client.id, editedClientName);
                                            } else if (e.key === 'Escape') {
                                                setEditingClientId(null);
                                            }
                                        }}
                                        style={{...inputStyles.input, maxWidth: '65px'}}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            maxWidth: '84px',
                                            minWidth: '84px',
                                            marginLeft: '8px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            verticalAlign: 'middle',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {client.name}
                                </span>
                                )}
                                <div style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                                    <div className={'edit-btn'} onClick={(e) => {
                                        e.stopPropagation();
                                        setEditingClientId(client.id);
                                        setEditedClientName(client.name);
                                    }}>
                                        ✎
                                    </div>
                                    <div style={{fontSize: '28px'}} className="remove-btn"
                                         onClick={() => handleRemoveClient(client)}>
                                        ×
                                    </div>
                                </div>
                            </div>
                        </Tooltip>
                    </div>
                ))}
            </div>
            {visibleClient && (
                <div className="bots-main-content">
                    <div className={`bots-sub-div-container bots-visible`}>
                        <div className="bots-sub-div">
                            <Tooltip text={'main'}>
                                <div
                                    className={`bots-card ${activeSubMenu === 0 ? 'bots-card-active' : ''}`}
                                    onClick={() => handleSubMenuClick(0)}
                                >
                                    <img width={35} height={35} src={ConfigurationsIcon}/>
                                </div>
                            </Tooltip>
                            <Tooltip text={'integrations'}>
                                <div
                                    className={`bots-card ${activeSubMenu === 1 ? 'bots-card-active' : ''}`}
                                    onClick={() => handleSubMenuClick(1)}
                                >
                                    <img width={35} height={35} src={IntegrationsIcon}/>
                                </div>
                            </Tooltip>
                            <Tooltip text={'settings'}>
                                <div
                                    className={`bots-card ${activeSubMenu === 2 ? 'bots-card-active' : ''}`}
                                    onClick={() => handleSubMenuClick(2)}
                                >
                                    <img width={35} height={35} src={FunctionsIcon}/>
                                </div>
                            </Tooltip>
                            {features.includes(config.features.BLACK_LIST) && (
                                <Tooltip text={'blackList'}>
                                    <div
                                        className={`bots-card ${activeSubMenu === 3 ? 'bots-card-active' : ''}`}
                                        onClick={() => handleSubMenuClick(3)}
                                    >
                                        <img width={35} height={35} src={BlackListIcon}/>
                                    </div>
                                </Tooltip>
                            )}
                            {(features.includes(config.features.CUSTOMIZE_WEBCHAT) || features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS))  && (
                                <Tooltip text={'webChatDesignAndConfigs'}>
                                    <div
                                        className={`bots-card ${activeSubMenu === 4 ? 'bots-card-active' : ''}`}
                                        onClick={() => handleSubMenuClick(4)}
                                    >
                                        <img width={35} height={35} src={DesignIcon}/>
                                    </div>
                                </Tooltip>
                            )}
                            {(features.includes(config.features.CATEGORIES) || features.includes(config.features.TEMPLATES)) && (
                                <Tooltip text={'resources'}>
                                    <div
                                        className={`bots-card ${activeSubMenu === 5 ? 'bots-card-active' : ''}`}
                                        onClick={() => handleSubMenuClick(5)}
                                    >
                                        <img width={35} height={35} src={CategoriesIcon}/>
                                    </div>
                                </Tooltip>
                            )}
                            <Tooltip text={'operators'}>
                                <div
                                    className={`bots-card ${activeSubMenu === 6 ? 'bots-card-active' : ''}`}
                                    onClick={() => handleSubMenuClick(6)}
                                >
                                    <img width={35} height={35} src={UsersIcon}/>
                                </div>
                            </Tooltip>
                        </div>
                        {activeSubMenu !== null && (
                            <div
                                className={
                                activeSubMenu !== 0 &&
                                activeSubMenu !== 1 &&
                                activeSubMenu !== 2 &&
                                activeSubMenu !== 5 &&
                                activeSubMenu !== 4 &&
                                activeSubMenu !== 6
                                    ? "bots-bottom-div"
                                    : "bots-bottom-div-2"}>
                                <div className="bots-bottom-content">
                                    {{
                                        0: <Configurations tariff={tariff} user={user} client={visibleClient}/>,
                                        1: <Channels tariff={tariff} user={user} client={visibleClient}
                                                     addNotification={addNotification}/>,
                                        2: <Functions tariff={tariff} user={user} client={visibleClient}/>,
                                        3: features.includes(config.features.BLACK_LIST)
                                            ? <BlackList tariff={tariff} user={user} client={visibleClient}/>
                                            : null,
                                        4: (features.includes(config.features.CUSTOMIZE_WEBCHAT) || features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS))
                                            ? <Design tariff={tariff} client={visibleClient}/>
                                            : null,
                                        5: (features.includes(config.features.CATEGORIES) || features.includes(config.features.TEMPLATES))
                                            ? <Resources clients={clients} tariff={tariff} client={visibleClient} user={user}/>
                                            : null,
                                        6: <Members tariff={tariff} client={visibleClient}/>
                                    }[activeSubMenu]}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

Bots.propTypes = {
    clients: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    openCreateClientModal: PropTypes.func.isRequired,
    handleRemoveClient: PropTypes.func.isRequired,
    closeCreateClientModal: PropTypes.func.isRequired,
    createClient: PropTypes.func.isRequired,
    handleImageChange: PropTypes.func.isRequired,
    tariff: PropTypes.object.isRequired
};

export default Bots;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Bots.jsx